import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CompanySelectPage } from './company-select.page';

const routes: Routes = [
  {
    path: '',
    component: CompanySelectPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CompanySelectPageRoutingModule {}
